import { render, staticRenderFns } from "./VASPostingSettings.vue?vue&type=template&id=48cd5fc7&scoped=true"
import script from "./VASPostingSettings.vue?vue&type=script&lang=js"
export * from "./VASPostingSettings.vue?vue&type=script&lang=js"
import style0 from "./VASPostingSettings.vue?vue&type=style&index=0&id=48cd5fc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cd5fc7",
  null
  
)

export default component.exports